import * as React from 'react';
export const spaylaterSvg = React.forwardRef(function spaylaterSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EE4D2D',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.75 24.773h-6.1c-1.45 0-2.175-.724-2.175-2.15v-4.225c0-.375.075-.5.475-.5 3.175-.05 5.625-2.3 5.975-5.424.05-.425.2-.55.625-.525h7.525c1.25 0 1.925.7 1.925 1.925v8.925c0 1.325-.675 1.974-2 1.974h-6.25Zm7.025-6.45c0-.7-.625-1.3-1.325-1.274-.7 0-1.3.625-1.275 1.325 0 .675.625 1.25 1.3 1.25.7 0 1.3-.625 1.3-1.3Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.75 11.849a4.887 4.887 0 0 1-4.825 4.875C7.25 16.724 5 14.524 5 11.849c0-2.65 2.2-4.85 4.85-4.85a4.865 4.865 0 0 1 4.9 4.85Zm-5.3-1.475v1.575c0 .45.2.625.65.625h2.225c.3 0 .575-.075.6-.425 0-.375-.25-.475-.6-.475-.475 0-.95-.025-1.4 0-.45.025-.625-.075-.6-.575.05-.8 0-1.6 0-2.4 0-.325-.15-.55-.475-.525-.3 0-.4.25-.4.55v1.65Zm10.45.6c-1.15.05-2.3.125-3.45.2-.35 0-.55 0-.575-.425-.025-.375-.175-.75-.325-1.125-.1-.275-.025-.325.225-.375 2.275-.275 4.525-.6 6.8-.875.7-.075 1.25.375 1.425 1.05.025.15.05.3.05.475 0 1 .15.875-.85.925l-3.275.15H19.9Z',
      fill: '#fff',
    }),
  );
});
spaylaterSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var spaylater = {
  category: 'brand',
  colorable: false,
  name: 'spaylater',
  svg: spaylaterSvg,
};
